// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__I3JSv","left":"Virtual_left__pawIP","wrapper":"Virtual_wrapper__ltIbq"};